import React, { useEffect, useState, useContext } from "react";
import { FirstStep } from "./components/FirstStep";
import { SecondStep } from "./components/SecondStep";
import { simplyClick, getTTI, sendScreenResolution } from "./helpers";
import { landingId } from "./constant/index";
import { useAppendLandingId } from "./hooks/useAppendLandingId";
import { useSessionData } from "ui-components";
import { ContextProfileUser } from "./lib/profileContext";

function App() {
  const [step, setStep] = useState(1);
  let content = null;

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useAppendLandingId(landingId);

  useEffect(() => {
    const element = document.getElementById("translation-checkpoint");
    if (!element) return;

    const initText = element.textContent.trim();
    let previousText = element.textContent.trim();

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim();
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "footer_links",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    return () => {
      observer.disconnect();
      clearTimeout(timer);
    };
  }, []);

  switch (step) {
    case 1:
      content = (
        <>
          <FirstStep
            nextStep={() => setStep(2)}
            setData={setData}
            data={data}
          />
        </>
      );
      break;
    case 2:
      content = (
        <>
          <SecondStep
            setData={setData}
            data={data}
            nextStep={() => setStep(1)}
          />
        </>
      );
      break;
    default:
  }

  return <>{content}</>;
}

export default App;
